module.exports = __webpack_public_path__ + "static/media/light_green_dot.77f059ca.png";